import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import ProfilesPage from './pages/ProfilesPage';
import AlbumPage from './pages/AlbumPage';
import AccessDeniedPage from './pages/AccessDeniedPage';
import NotFoundPage from './pages/NotFoundPage';
import InvitePage from './pages/InvitePage';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminMediaUpload from './pages/admin/AdminMediaUpload';
import AdminInvites from './pages/admin/AdminInvites';
import AdminUsers from './pages/admin/AdminUsers';
import AdminAlbums from './pages/admin/AdminAlbums';
import AdminSettings from './pages/admin/AdminSettings';
import ProtectedRoute from './auth/ProtectedRoute';

function LegacyAlbumRedirect() {
  const { slug } = useParams();
  return <Navigate to={`/v/${slug}`} replace />;
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/invite/:token" element={<InvitePage />} />
      <Route
        path="/profiles"
        element={(
          <ProtectedRoute>
            <ProfilesPage />
          </ProtectedRoute>
        )}
      />
      <Route
        path="/v/:slug"
        element={(
          <ProtectedRoute>
            <AlbumPage />
          </ProtectedRoute>
        )}
      />
      <Route path="/:slug" element={<LegacyAlbumRedirect />} />
      <Route path="/403" element={<AccessDeniedPage />} />
      <Route path="/404" element={<NotFoundPage />} />
      
      {/* Admin routes */}
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/media" element={<AdminMediaUpload />} />
      <Route path="/admin/invites" element={<AdminInvites />} />
      <Route path="/admin/users" element={<AdminUsers />} />
      <Route path="/admin/albums" element={<AdminAlbums />} />
      <Route path="/admin/settings" element={<AdminSettings />} />
      
      <Route path="*" element={<Navigate to="/404" replace />} />
    </Routes>
  );
}

export default App;